export default __webpack_public_path__ + "static/media/fav.34f87439.svg";